import React from "react";
import { useOutletContext } from "react-router-dom";

export default function About() {
  const { settings } = useOutletContext() || {};
  return (
    <div className="max-w-4xl mx-auto px-6 md:px-10 py-20" data-testid="about-page">
      <div className="text-center">
        <div className="text-xs tracking-[0.25em] uppercase text-larc-gold">— Atölyemiz</div>
        <h1 className="font-heading text-5xl md:text-7xl tracking-tight mt-3">Hikâyemiz</h1>
      </div>

      <div className="mt-12 aspect-[16/9] rounded-2xl overflow-hidden">
        <img src="https://images.unsplash.com/photo-1559032195-42b455e61dfe?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000" alt="" className="w-full h-full object-cover" />
      </div>

      <div className="mt-12 space-y-8 text-larc-muted leading-relaxed text-lg font-light">
        <p>
          <span className="font-heading italic text-larc-ink text-2xl">{settings?.logo_text || "Larcraft"}</span>, küçük bir atölyede başlayan büyük bir tutkudur.
          El yapımı mum ve sabunlarımız, malzemenin saflığına ve üretimin yavaşlığına olan inancımızla
          her gün dökülür.
        </p>
        <p>
          Soya bazlı mumlarımız düşük sıcaklıkta, doğal pamuk fitiller kullanılarak hazırlanır.
          Sabunlarımız soğuk pres yöntemiyle, %100 doğal yağ ve esanslarla, kimyasal eklemeden üretilir.
          Her parti küçüktür çünkü her parçanın koku, doku ve görsel kalitesi bizim için bireysel bir mesele.
        </p>
        <p>
          Yaptığımız işe duyduğumuz sevgi, ambalajda da hissedilsin istedik. Kraft kâğıt, soft renkli iplikler,
          el yazısıyla yazılmış notlar… çünkü hediye duygusu ürünün kokusu kadar önemlidir.
        </p>
        <p>
          Bizimle paylaşılan her özel an, bizim için yeni bir tasarım sebebi. Kişiye özel taleplerinizi
          atölyemize iletmekten çekinmeyin — birlikte unutulmaz parçalar yapalım.
        </p>
      </div>
    </div>
  );
}
